// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"0":"vendors","9":"main"}[chunkId] + "." + {"0":"e9cede77ec1fd0968e11","9":"020c20da745c364fdc58"}[chunkId] + ".min.css";
};